import { c as _c } from "react/compiler-runtime";
import React, { createContext, ReactNode, useContext } from 'react';
type AppLayoutPanelContextValue = {
  id: string;
};
const AppLayoutPanelContext = createContext<AppLayoutPanelContextValue>({
  id: `app-layout-panel.${Math.random()}`
});
export const useParentAppLayoutPanel = () => {
  return useContext(AppLayoutPanelContext);
};
export const AppLayoutPanelProvider: React.FC<{
  id: string;
  children: ReactNode;
}> = props => {
  const $ = _c(5);
  let t0;
  if ($[0] !== props.id) {
    t0 = {
      id: props.id
    };
    $[0] = props.id;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.children || $[3] !== t0) {
    t1 = <AppLayoutPanelContext.Provider value={t0}>{props.children}</AppLayoutPanelContext.Provider>;
    $[2] = props.children;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export { AppLayoutPanelContext };